import type { Template } from "@/react/components/SettingsApp/Workflows/generated/WorkflowsApi.types";

export interface MomentumModalConfig {
  template_key: string;
  template_type: Template["template_type"];
}

export const momentumModalConfigs = {
  invitation_link_momo: {
    template_key: "welcome_message",
    template_type: "dynamic",
  },
  member_tag_momo: {
    template_key: "add_member_to_space_by_tag",
    template_type: "dynamic",
  },
  form_published_momo: {
    template_key: "form_submitted_email_sequence",
    template_type: "dynamic",
  },
  paywall_momo: {
    template_key: "message_new_paywall_subscriber",
    template_type: "dynamic",
  },
} as const;

export type MomentumModalConfigs = typeof momentumModalConfigs;

export const getMomentumModalConfig = (
  modalType: keyof MomentumModalConfigs,
): MomentumModalConfig | undefined => momentumModalConfigs[modalType];
